var _g, _g2, _g3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDigitellieWordmark(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 20",
    style: {
      enableBackground: "new 0 0 100 20"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M8.6,0C8.5,0,8.5,0,8.6,0L8.6,0H5.8v4.4h2.7c0,0,0.1,0,0.1,0c2,0,3.6,1.6,3.6,3.6c0,2-1.6,3.6-3.6,3.6c0,0-0.1,0-0.1,0v0 H5.8v4.4h2.7v0c0,0,0.1,0,0.1,0c4.4,0,8-3.6,8-7.9C16.6,3.6,13,0,8.6,0z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 4.4,
    height: 4.4
  }), /*#__PURE__*/React.createElement("rect", {
    y: 11.5,
    width: 4.4,
    height: 4.4
  }), /*#__PURE__*/React.createElement("rect", {
    y: 5.8,
    width: 4.4,
    height: 4.4
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M17.9,1.9h3.9v2.6h-3.9V1.9z M17.9,5.7h3.9v10.1h-3.9V5.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.5,5.7h3.7v9.6l0,0.4c0,0.6-0.1,1.2-0.4,1.8c-0.3,0.6-0.6,1-1.1,1.4c-0.5,0.4-1,0.6-1.7,0.8c-0.7,0.2-1.5,0.2-2.4,0.2 c-2.1,0-3.5-0.3-4.2-0.9c-0.8-0.6-1.2-1.4-1.2-2.5c0-0.1,0-0.3,0-0.5l3.8,0.4c0.1,0.3,0.2,0.6,0.4,0.7c0.3,0.2,0.7,0.3,1.1,0.3 c0.6,0,1-0.1,1.3-0.4c0.3-0.3,0.4-0.8,0.4-1.6V14c-0.4,0.5-0.8,0.8-1.2,1c-0.6,0.3-1.3,0.5-2,0.5c-1.4,0-2.5-0.6-3.3-1.8 c-0.6-0.8-0.9-2-0.9-3.3c0-1.6,0.4-2.8,1.2-3.6c0.8-0.8,1.8-1.2,3-1.2c0.8,0,1.5,0.1,2,0.4c0.5,0.3,1,0.7,1.5,1.3V5.7z M27.8,10.7 c0,0.7,0.2,1.3,0.5,1.6c0.3,0.4,0.7,0.5,1.2,0.5c0.5,0,0.9-0.2,1.2-0.5c0.3-0.4,0.5-0.9,0.5-1.7c0-0.7-0.2-1.3-0.5-1.7 S30,8.3,29.4,8.3c-0.5,0-0.9,0.2-1.2,0.5C27.9,9.2,27.8,9.8,27.8,10.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.7,1.9h3.9v2.6h-3.9V1.9z M37.7,5.7h3.9v10.1h-3.9V5.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.9,1.9v3.9H51v2.8h-2.2v3.6c0,0.4,0,0.7,0.1,0.9c0.1,0.2,0.4,0.3,0.7,0.3c0.3,0,0.7-0.1,1.2-0.2l0.3,2.7 c-1,0.2-1.9,0.3-2.7,0.3c-1,0-1.7-0.1-2.2-0.4c-0.5-0.2-0.8-0.6-1-1.1c-0.2-0.5-0.3-1.3-0.3-2.5V8.6h-1.4V5.7h1.4V3.9L48.9,1.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.3,11.8h-7.9c0.1,0.6,0.2,1.1,0.5,1.4c0.4,0.4,0.9,0.7,1.5,0.7c0.4,0,0.8-0.1,1.1-0.3c0.2-0.1,0.4-0.3,0.7-0.6l3.9,0.4 c-0.6,1-1.3,1.7-2.1,2.2c-0.8,0.4-2,0.7-3.6,0.7c-1.4,0-2.4-0.2-3.2-0.6c-0.8-0.4-1.4-1-1.9-1.8c-0.5-0.8-0.8-1.8-0.8-2.9 c0-1.6,0.5-2.9,1.5-3.8c1-1,2.4-1.5,4.2-1.5c1.5,0,2.6,0.2,3.5,0.7c0.8,0.4,1.5,1.1,1.9,1.9c0.4,0.8,0.7,1.9,0.7,3.3V11.8z  M60.3,9.9c-0.1-0.8-0.3-1.3-0.6-1.6c-0.3-0.3-0.8-0.5-1.3-0.5c-0.6,0-1.1,0.2-1.5,0.7c-0.2,0.3-0.4,0.8-0.5,1.4H60.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.2,1.9h3.9v14h-3.9V1.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.8,1.9h3.9v14h-3.9V1.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.4,1.9h3.9v2.6h-3.9V1.9z M79.4,5.7h3.9v10.1h-3.9V5.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.2,11.8h-7.9c0.1,0.6,0.2,1.1,0.5,1.4c0.4,0.4,0.9,0.7,1.5,0.7c0.4,0,0.8-0.1,1.1-0.3c0.2-0.1,0.4-0.3,0.7-0.6l3.9,0.4 c-0.6,1-1.3,1.7-2.1,2.2c-0.8,0.4-2,0.7-3.6,0.7c-1.4,0-2.4-0.2-3.2-0.6c-0.8-0.4-1.4-1-1.9-1.8c-0.5-0.8-0.8-1.8-0.8-2.9 c0-1.6,0.5-2.9,1.5-3.8c1-1,2.4-1.5,4.2-1.5c1.5,0,2.6,0.2,3.5,0.7c0.8,0.4,1.5,1.1,1.9,1.9c0.4,0.8,0.7,1.9,0.7,3.3V11.8z  M93.2,9.9c-0.1-0.8-0.3-1.3-0.6-1.6c-0.3-0.3-0.8-0.5-1.3-0.5c-0.6,0-1.1,0.2-1.5,0.7c-0.2,0.3-0.4,0.8-0.5,1.4H93.2z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M98.3,15.8v-1h-0.4v-0.1h0.9v0.1h-0.4v1H98.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99,15.8v-1.1h0.2l0.3,0.8c0,0.1,0,0.1,0.1,0.2c0,0,0-0.1,0.1-0.2l0.3-0.8h0.2v1.1h-0.1v-0.9l-0.3,0.9h-0.1l-0.3-0.9v0.9 H99z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDigitellieWordmark);
export default __webpack_public_path__ + "static/media/digitellie-wordmark.7fa521de7e95d1b60998348244a3ee95.svg";
export { ForwardRef as ReactComponent };